export default {
  message: {
    title: 'Official Customer Service',
    dispute: {
      id: 'Dispute ID',
      createdAt: 'Initiation Time',
      orderDetails: 'Order Details',
      inArbitration: 'In Arbitration',
      serialNumber: 'Serial Number',
      orderNumber: 'Order Number',
      txnAmount: 'Total Amount',
      enableRefundAmount: 'Refundable Amount',
      holderEmail: 'Consumer Email',
      holderName: 'Consumer Name',
      txnTime: 'Order Date',
      txnWebsite: 'Transaction Website',
      productInfo: 'Products',
      endDispute: 'Close Dispute',
      applyArbitration: 'Apply For Arbitration',
      reset: 'Reset',
      send: 'Send',
      apply: 'Initiate Disputes',
      cardNoLast4: 'Last 4 Digits Of Card Number',
      type: 'Dispute Type',
      claims: 'Claims',
      claimsPlaceholder: 'Please enter the main reason for your dispute and the expected solution',
      nameHello: 'Dear {name}',
      orderInfo: 'You made a <span class="amount"> {currency} {amount} </span> purchase on <a href="{link}" target="_blank" class="website"> {website} </a> from <span class="date"> {date} </span>',
      tip: 'If you have any questions about this order, please enter and send dispute information',
      systemMessage: 'System messages',
      typeOptions: {
        unknow: 'Unknow',
        fraud: 'Fraud',
        unauthorized: 'Unauthorized',
        wrongGoods: 'Products Discrepancies',
        productNotReceived: 'Product Not Received',
        defectiveMerchandise: 'Defective Merchandise',
        incorrectTransaction: 'Incorrect Transaction',
        wrongAddress: 'Wrong address',
        creditNotProcessed: 'Credit Not Processed'
      },
      status: {
        0: 'In Coordination',
        1: 'In Arbitration',
        // 2: '已仲裁',去掉这个状态，不翻译
        3: 'Ended'
      },
      applyArbitrationSuccess: 'You have applied for arbitration',
      endDisputeSuccess: 'You have ended this dispute',
      comfirm: 'Submit',
      logisticsNumber: 'Tracking No'
    },
    checkout: {
      title: 'صفحة الدفع الآمنة',
      description: 'نحن نحتفظ بمعلوماتك المالية مشفرة بأمان',
      methodErrorTips: '.نأسف، الدولة التي اخترتها غير مدعومة حالياً. يرجى اختيار دولة أخرى ومحاولة مرة أخرى.',
      recommendation: 'توصية',
      cardNumber: 'رقم البطاقة',
      cardName: 'اسم صاحب البطاقة',
      cvv: 'CVV',
      expiredDate: 'تاريخ انتهاء الصلاحية',
      billingInfo: 'معلومات الفواتير',
      country: 'بلد',
      state: 'ولاية',
      firstName: 'الاسم الأول',
      lastName: 'الاسم الأخير',
      document: 'وثيقة',
      city: 'مدينة',
      address: 'عنوان',
      streetNumber: 'رقم الشارع',
      zipCode: 'رمز البريد',
      email: 'البريد الإلكتروني',
      phone: 'رقم الهاتف',
      pay: 'دفع',
      choosePaymentMethod: 'اختر طريقة الدفع',
      continue: 'استمرار',
      later: 'لاحقا',
      returnToMerchant: 'إلغاء والعودة إلى التاجر',
      resultToMerchant: 'العودة إلى التاجر',
      orderId: 'رقم الطلب',
      orderAmount: 'مبلغ الطلب',
      billingDescriptor: 'وصف الفاتورة',
      goodsName: 'اسم السلعة',
      timeLimit: 'يرجى إكمال الدفع خلال الفترة المحددة، وإلا سيكون الصفحة مهلة',
      otherPaymentMethods: 'طرق الدفع الأخرى',
      close: 'إغلاق',
      paymentErrorTitle: 'فشل الدفع',
      paymentErrorTip: 'لم يتم معالجة دفعتك بنجاح. يرجى المحاولة مرة أخرى.',
      paymentFailed: 'فشل عملية الدفع',
      continueShopping: 'استمر في التسوق',
      paymentSuccess: 'تمت عملية الدفع بنجاح',
      paymentPending: 'تم إرسال الدفع، مؤكد',
      correctDateTip: 'يرجى إدخال تاريخ انتهاء صالح',
      correctCardNumberTip: 'يرجى إدخال رقم بطاقة صالح',
      correctSecurityCodeTip: 'يرجى إدخال رمز الأمان الصحيح',
      mobileMoneyOperator: 'مشغل المال المحمول',
      bank: 'بنك',
      correctEmailAddressTip: 'الرجاء إدخال عنوان بريد إلكتروني صحيح',
      notSupportPaymentTip: ' {type}  البيئة الحالية لا تدعم الدفع عبر ',
      addValidPaymentCard: 'يرجى إضافة بطاقة صالحة للدفع',
      timeLimitTip: 'سيتم خصم الرسوم قبل 12 ساعة من انتهاء فترة التجربة (<span class="date">{date}</span>)، وسيتم التجديد كل <span class="date">{month}</span> أشهر بمبلغ <span class="amount"> {amount} {currency}</span>، ويمكن الإلغاء في أي وقت',
      product: 'المنتج/الخدمة',
      subscribeType: 'نوع الاشتراك',
      renewCycle: 'دورة التجديد',
      renewAmount: 'مبلغ التجديد',
      subscribePay: 'اشترك وادفع',
      readAgreement: "اقرأ ووافق على <span class='protocol-link' style='color: #31a7da;'>اتفاقية التجديد التلقائي</span>",
      depict: 'الوصف',
      copyQrCode: 'نسخ رمز الاستجابة السريعة',
      copySuccess: 'نسخ بنجاح',
      copyError: 'فشل النسخ',
      refreshQrCode: 'تحديث رمز الاستجابة السريعة'
    },
    subscribe: {
      yourSubscribe: 'اشتراكك',
      unsubscribeTip: 'للإلغاء، يمكنك النقر على زر [إلغاء الاشتراك] في أسفل الصفحة.',
      renewTip: 'سيتم الخصم <span class="amount"> {amount} {currency}</span> في <span class="date">{date}</span>، ويمكن الإلغاء في أي وقت',
      unsubscribe: 'إلغاء الاشتراك',
      autoRenew: 'اتفاقية التجديد التلقائي',
      unsubscribeTipTwo: 'إذا قمت بالإلغاء الآن، يمكنك الاستمرار في استخدام هذا الاشتراك حتى <span class="date">{date}</span>.',
      emailVerifyTip: 'التحقق من البريد الإلكتروني',
      inputCodeTip: 'الرجاء إدخال رمز التحقق',
      sendSuccessTip: 'تم إرسال رمز التحقق بنجاح',
      sendErrorTip: 'فشل إرسال رمز التحقق',
      unsubscribeSuccessTip: 'تم إلغاء الاشتراك بنجاح',
      unsubscribeErrorTip: 'فشل إلغاء الاشتراك',
      sendCodeTip: 'إعادة الإرسال بعد {code} ثانية',
      sendEmailTip: 'الحصول على رمز التحقق',
      daily: 'كل يوم',
      weekly: 'كل 7 أيام',
      monthly: 'كل 30 يوماً',
      quarterly: 'كل 90 يوماً',
      semiAnnually: 'كل 180 يوماً',
      annually: 'كل 365 يوماً',
      regularRenewal: 'التجديد الدوري',
      oneTime: 'مرة واحدة',
      inputNumberTip: 'الرجاء إدخال رقم',
      eachCalendarMonth: 'كل شهر ميلادي'
    },
    common: {
      confirm: 'تأكيد',
      cancel: 'الغاء',
      uploadImgErrorTip: 'يُمكن فقط رفع الصور',
      inputMessageTip: 'يرجى ملء المحتوى',
      sendSuccessTip: 'تم الإرسال بنجاح',
      sendErrorTip: 'فشل الإرسال',
      inputPlaceholder: 'يرجى إدخال {field}',
      selectPlaceholder: 'يرجى الاختيار {field}',
      correctFormat: 'يرجى إدخال التنسيق الصحيح، على سبيل المثال:{example}'
    }
  }
}
